import { omit } from 'lodash';

const StoreOperationType = {
    READ: 'listen',
    WRITE: 'trigger'
};

export const StoreOperation = {
    // eslint-disable-next-line no-restricted-syntax
    ALL: [StoreOperationType.READ, StoreOperationType.WRITE],
    // eslint-disable-next-line no-restricted-syntax
    READ: [StoreOperationType.READ],
    // eslint-disable-next-line no-restricted-syntax
    WRITE: [StoreOperationType.WRITE]
};

const VARS_PROP_KEY = 'varAliases';

const resolveVarNames = (varAliases, operationType) => {
    return Object.entries(varAliases).filter(([, { [operationType]: operation }]) => operation != null).map(([varAlias]) => varAlias);
};

class ElemStoreMeta {
    _vm;

    _varAliases;

    constructor(vm, varAliases = null) {
        this._vm = vm;
        this._varAliases = varAliases;
    }

    use(varAliases) {
        return new this.constructor(this._vm, varAliases);
    }

    get varAliases() {
        return this._varAliases ?? this._vm.props[VARS_PROP_KEY];
    }

    get read() {
        return resolveVarNames(this.varAliases, StoreOperationType.READ);
    }

    get write() {
        return resolveVarNames(this.varAliases, StoreOperationType.WRITE);
    }

    get readMap() {
        return this.read.reduce((acc, varAlias) => ({
            ...acc,
            [varAlias]: this.varAliases[varAlias][StoreOperationType.READ]
        }), {});
    }

    get writeMap() {
        return this.write.reduce((acc, varAlias) => ({
            ...acc,
            [varAlias]: this.varAliases[varAlias][StoreOperationType.WRITE]
        }), {});
    }
}

class PanelStoreMeta extends ElemStoreMeta {
    setVar({ varAlias, storeVar = varAlias, operation = StoreOperation.ALL }) {
        const { varAliases } = this;
        operation.forEach((op) => {
            if (varAliases[varAlias]?.[op] == null) {
                varAliases[varAlias] = {
                    ...varAliases[varAlias],
                    [op]: storeVar
                };
            }
        });
        // eslint-disable-next-line no-param-reassign
    }

    deleteVar({ varAlias, operation = StoreOperation.ALL }) {
        const { varAliases } = this;

        const newVarAliasDefinition = omit(varAliases[varAlias], operation);
        const { listen, trigger } = newVarAliasDefinition;
        if (listen == null && trigger == null) {
            delete varAliases[varAlias];
            return;
        }
        varAliases[varAlias] = newVarAliasDefinition;
    }

    saveVars() {
        this._vm.propChanged(VARS_PROP_KEY);
    }
}

export const createElemStoreMeta = (vm) => ({
    get vars() {
        return new ElemStoreMeta(vm);
    }
});
export const createPanelStoreMeta = (vm) => new PanelStoreMeta(vm);
